// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { fetchQuery, graphql } from 'react-relay';
import { createOperationDescriptor } from 'relay-runtime';
import 'rxjs/add/operator/map';
import getRelayEnvironment from '@atlassian/jira-relay-environment/src/index.tsx';
import HasDevelopmentInProjectQuery, {
	type hasDevelopmentInProjectQuery$data,
} from '@atlassian/jira-relay/src/__generated__/hasDevelopmentInProjectQuery.graphql';

export const getHasDevelopmentDataInProject = (
	projectAri: string,
	updatedFrom: string,
	isJiraAdmin: boolean,
	isSiteAdmin: boolean,
): Promise<boolean> => {
	if (isJiraAdmin || isSiteAdmin) {
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		const developmentDataQuery = graphql`
			query hasDevelopmentInProjectQuery($projectAri: ID!, $updatedFrom: DateTime) {
				devOps {
					ariGraph {
						branchRelationships: relationships(
							filter: {
								from: $projectAri
								type: "project-associated-branch"
								updatedFrom: $updatedFrom
							}
							first: 1
						) {
							nodes {
								__typename
							}
						}
						buildRelationships: relationships(
							filter: {
								from: $projectAri
								type: "project-associated-build"
								updatedFrom: $updatedFrom
							}
							first: 1
						) {
							nodes {
								__typename
							}
						}
						prRelationships: relationships(
							filter: {
								from: $projectAri
								type: "project-associated-pr"
								updatedFrom: $updatedFrom
							}
							first: 1
						) {
							nodes {
								__typename
							}
						}
					}
				}
			}
		`;

		const variables = {
			projectAri,
			updatedFrom,
		};

		const request = fetchQuery(getRelayEnvironment(), developmentDataQuery, variables, {
			fetchPolicy: 'store-or-network',
		});

		/* fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
       data will remain saved in the Relay store at any point after the request completes. We need to
       explicitly retain the operation to ensure it doesn't get deleted. See https://relay.dev/docs/api-reference/fetch-query/#behavior */
		getRelayEnvironment().retain(
			createOperationDescriptor(HasDevelopmentInProjectQuery, variables),
		);

		return request.toPromise().then((result) => {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			const data = result as hasDevelopmentInProjectQuery$data;
			return (
				(data?.devOps?.ariGraph?.branchRelationships?.nodes ?? []).length > 0 ||
				(data?.devOps?.ariGraph?.buildRelationships?.nodes ?? []).length > 0 ||
				(data?.devOps?.ariGraph?.prRelationships?.nodes ?? []).length > 0
			);
		});
	}
	return Promise.resolve(false);
};
